<template>
  <div v-if="show" class="flex justify-end fixed left-0 top-0 w-full h-full bg-grays-900/[0.43] z-50">
    <div class="flex flex-col w-[431px] bg-white border border-grays-400 rounded-r ">
      <!-- close button -->
      <button
          class="flex justify-center items-center absolute left-[5px] top-[5px] h-[28px] w-[28px]"
          @click="handleClose"
      >
        <span class="material-symbols-rounded text-grays-700 text-[20px]">close</span>
      </button>
      <!-- intro -->
      <h2 class="text-primary-700 text-2xl font-bold pt-[37px] pr-[13px]">Messages from the System</h2>
      <!-- tabs switcher -->
      <div class="flex flex-row mt-[34px] relative">
        <button class="text-primary-700 text-xl font-bold px-[13px] pb-[14px] border-b-2 border-primary-700 z-10">
          Unread
        </button>
        <button class="text-grays-700 text-xl font-medium px-[13px] pb-[14px] border-b-2 border-transparent z-10"> All
        </button>
        <div class="w-full absolute border-b-2 border-primary-100 bottom-0 left-0 z-0"></div>
      </div>
      <!-- notifications plh -->
      <div class="flex flex-1 flex-col items-center custom-scroll-bar overflow-y-auto overflow-x-hidden">
        <!-- notification -->
        <div class="item w-full flex flex-row px-[14px] py-[16px] border-b">
          <div class="flex flex-row w-full gap-[8px]">
            <div class="flex justify-center items-center h-[28px] w-[28px] rounded-full bg-complementary-300">
              <span class="material-symbols-rounded text-[20px] text-complementary-900">sell</span>
            </div>
            <div class="flex flex-col flex-1">
              <div class="flex flex-row justify-between w-full">
                <p class="text-grays-900 text-lg font-medium select-none">new credit</p>
                <button class="w-[24px] h-[24px] flex justify-center items-center">
                  <span class="material-symbols-rounded text-base text-error">delete</span>
                </button>
              </div>
              <p class="text-grays-700 text-sm font-regular">amount: 38.5 ₪ </p>
            </div>
          </div>
        </div>
        <!-- notification -->
        <div class="item w-full flex flex-row px-[14px] py-[16px] border-b">
          <div class="flex flex-row w-full gap-[8px]">
            <div class="flex justify-center items-center h-[28px] w-[28px] rounded-full bg-complementary-300">
              <span class="material-symbols-rounded text-[20px] text-complementary-900">shopping_basket</span>
            </div>
            <div class="flex flex-col flex-1">
              <div class="flex flex-row justify-between w-full">
                <p class="text-grays-900 text-lg font-medium select-none">your order is waiting for pickup</p>
                <button class="w-[24px] h-[24px] flex justify-center items-center">
                  <span class="material-symbols-rounded text-base text-error">delete</span>
                </button>
              </div>
              <p class="text-grays-700 text-sm font-regular">date of pickup </p>
              <p class="text-primary-700 text-sm font-regular underline mt-[8px]">for more details</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notifications-modal",
  methods: {
    handleClose() {
      document.body.classList.remove("body-scroll-hidden");
      this.$store.dispatch("notifications/toggleShow")
    }
  },
  computed: {
    show() {
      if (this.$store.state.notifications.show)
        document.body.classList.add("body-scroll-hidden");
      return this.$store.state.notifications.show
    }
  },
}
</script>

<style>

</style>